import{jsxs as e,jsx as t}from"react/jsx-runtime";import{calculateRem as o,hexToRgba as n}from"@vds-core/utilities";import{AccessibilityTokens as i}from"@vds-tokens/accessibility";import{ColorTokens as r}from"@vds-tokens/color";import{ComponentTokens as a}from"@vds-tokens/component";import{useState as l}from"react";import c from"styled-components";const u=c.label.withConfig({displayName:"StyledLabel",componentId:"VDS__sc-hvmk2k-0"})`
  display: inline-flex;
  border-radius: 1rem;
  height: ${function({toggleHeight:e}){return o(e)}};
  width: ${o(52)};
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  ${function({disabled:e,surface:t,$keyboardFocused:n}){return!e&&n&&`\n      &:not(:hover) {\n        outline: none;\n        &::before {\n          border: ${o(i.focusring.borderwidth.value)} ${i.focusring.borderstyle.value} ${"dark"===t?i.color.focusring.ondark.value:i.color.focusring.onlight.value};\n          border-radius: 1rem;\n          content: '';\n          height: calc(100% + ${o(4)});\n          left: 50%;\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% + ${o(4)});\n        }\n      }\n      `}}
`,d=c.span.withConfig({displayName:"ToggleSwitchSlider",componentId:"VDS__sc-hvmk2k-1"})`
    border-radius: 1rem;
   border: ${function({disabled:e,surface:t,$surfaceType:n}){return"media"===n?e?`${o(1)} solid ${r.interactive.disabled[`on${t}`].value}`:`${o(1)} solid ${a.toggle.border.media[`on${t}`].value}`:`${o(1)} solid transparent`}};
    box-sizing: border-box;
    position: relative;
    display: inline-flex;
    cursor: ${function({disabled:e}){return e?null:"pointer"}};
    background-color: ${function({disabled:e,$on:t,surface:o,$surfaceType:i}){return function(e,t,o,i){return e?r.interactive.disabled[`on${o}`].value:"media"===i?t?r.palette.green36.value:n(r.palette.gray20.value,.5):t?a.toggle.container.on[`on${o}`].value:r.palette.gray44.value}(e,t,o,i)}};
    color: ${function({$calculateTextColor:e,disabled:t,surface:o}){return null==e?void 0:e(t,o)}};
    height: ${function({$toggleHeight:e}){return o(e)}};
    transition: background-color 100ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    width: ${o(52)};
    pointer-events: auto;
    &::before {
      background-color: ${function({disabled:e,surface:t}){return function(e,t){return e?a.toggle.knob.disabled[`on${t}`].value:r.palette.white.value}(e,t)}};
      border-radius: 50%;
      bottom: 0;
      content: '';
      height: ${function({$knobSize:e}){return o(e)}};
      left: ${function({$knobLeftPosition:e,$on:t}){return t?o(e):0}} !important; 
      margin-bottom: auto;
      margin-top: auto;
      padding-left: 0;
      position: absolute;
      top: 0;
      transition: left 100ms;
      width: ${function({$knobSize:e}){return o(e)}};
      z-index: 1;
      box-shadow: ${function({disabled:e}){return function(e){return e?`0px 1px 10px ${n(r.palette.black.value,.1)}, 0px 2px 4px ${n(r.palette.black.value,.04)}`:`0px 1px 10px ${n(r.palette.black.value,.24)}, 0px 2px 4px ${n(r.palette.black.value,.08)}`}(e)}};
      margin: ${o(1)}
      };
    }
  
    &:active,
    &:focus {
      outline: none;
    }
  `,s=c.input.withConfig({displayName:"ToggleInput",componentId:"VDS__sc-hvmk2k-2"})`
  opacity: 0;
  margin: 0;
  width: 2rem;
  height: 1rem;
  position: absolute;
  top: 0;
  pointer-events: auto;
  &:hover {
    cursor: pointer;
  }
`,p=function(o){const[n,i]=l(!1),{on:r=!1,disabled:a=!1,onKeyDown:c,handleSwitchClick:p,onChange:b=function(){},tabIndex:f,name:g,value:$,calculateTextColor:m,analyticsTrack:h,track:k,trackIgnore:v,clickStream:x,surface:y,surfaceType:w,inputId:S,focusId:T,textPosition:C,showText:I,ariaLabel:z,toggleHeight:_,knobSize:D,knobLeftPosition:H}=o,L=r;return e(u,{id:T,disabled:a,surface:y,htmlFor:S||g||"toggle",$keyboardFocused:n,$toggleHeight:_,children:[t(s,{"data-testid":"test-toggle","aria-label":z||g,type:"checkbox",disabled:a,checked:L,name:g,value:$,id:S||g||"toggle",tabIndex:f,"data-analyticstrack":h,"data-track":k,"data-track-ignore":v,"data-clickstream":x,onFocus:function(){i(!0)},onBlur:function(){i(!1)},onChange:b,onKeyDown:c,onClick:function(e){return p&&p(e)}}),t(d,{tabIndex:-1,"aria-hidden":!0,surface:y,$surfaceType:w,disabled:a,$on:L,$calculateTextColor:m,$textPosition:C,$showText:I,$toggleHeight:_,$knobSize:D,$knobLeftPosition:H})]})};export{p as default};
